






















































































import {
  defineComponent,
  reactive,
  computed,
  onMounted,
  PropType,
  SetupContext,
} from '@vue/composition-api'
import Multiselect from 'vue-multiselect'
import { cldInfo } from '@/@types/children/index'
import { defineObject } from '@/lib/define/use-define'
import {
  handleChangeKeyCamelSet,
  handleSortClaimChildData,
} from '@/lib/list/children-list-sort'
import { handleIsbeneficiaryIdView } from '@/lib/children/utils'
import {
  getAffiliationBadge,
  getAffiliationBadgeIconText,
} from '@/lib/achievements/utils'

type cldCustomInfo = Pick<
  cldInfo,
  | 'id'
  | 'firstName'
  | 'lastName'
  | 'beneficiaryId'
  | 'affiliation'
  | 'visitChildFlg'
> & {
  affiliation: string
  targetAffiliation: string
  visitText: string
}

type StateType = {
  selectCldValue: cldCustomInfo
  cldSelectArray: cldCustomInfo[]
  isShow: boolean
  mainText: string
  subText: string
}

export default defineComponent({
  components: {
    Multiselect,
  },
  props: {
    cldSelectArray: {
      type: Array as PropType<cldCustomInfo[]>,
      required: true,
      default: () => [],
    },
    label: {
      type: String,
      default: '児童の検索',
    },
    affiliationIconArray: {
      type: Array as PropType<{ [key: string]: string }[]>,
      required: false,
      default: () =>
        JSON.parse(JSON.stringify([...defineObject.AFFILIATION_ICON_ARRAY])),
    },
  },
  setup(props, context: SetupContext) {
    const state: StateType = reactive({
      selectCldValue: {
        id: '',
        firstName: '児童を選択または検索してください',
        lastName: '',
        affiliation: '',
        targetAffiliation: '',
        beneficiaryId: '',
        visitChildFlg: '0',
        visitText: '',
      },
      cldSelectArray: [],
      isShow: false,
      mainText: 'データを取得しています。',
      subText: '少々お待ち下さい。',
    })

    const selectCld = computed({
      get: () => {
        return state.selectCldValue
      },
      set: (value: cldCustomInfo) => {
        if (value) {
          state.selectCldValue = value
        } else {
          state.selectCldValue = {
            id: '',
            firstName: '児童を選択または検索してください',
            lastName: '',
            affiliation: '',
            targetAffiliation: '',
            beneficiaryId: '',
            visitChildFlg: '0',
            visitText: '',
          }
        }

        context.emit('select-cld', state.selectCldValue)
      },
    })

    const handleOptionLabel = (obj: { [key: string]: string }) => {
      return `${obj.affiliation}  ${obj.targetAffiliation} ${obj.visitText} ${
        handleIsbeneficiaryIdView(obj.beneficiaryId)
          ? obj.beneficiaryId
          : '受給者番号なし'
      } ${obj.lastName} ${obj.firstName}`
    }

    onMounted(() => {
      console.log(props.cldSelectArray)

      let cldSelectArray = handleChangeKeyCamelSet(props.cldSelectArray)

      cldSelectArray = handleSortClaimChildData(cldSelectArray, 'affiliation')

      cldSelectArray.forEach((cldInfo: cldCustomInfo) => {
        const targetAffiliation = props.affiliationIconArray.find(
          (affiliationObj: { [key: string]: string }) =>
            affiliationObj.value === cldInfo.affiliation
        )
        console.log(targetAffiliation)

        cldInfo.targetAffiliation = targetAffiliation
          ? targetAffiliation.text
          : ''

        cldInfo.visitText =
          cldInfo.visitChildFlg === '1' ? getAffiliationBadgeIconText('2') : ''
      })

      state.cldSelectArray.push(...cldSelectArray)
    })

    return {
      props,
      selectCld,
      state,
      getAffiliationBadge,
      handleOptionLabel,
      handleIsbeneficiaryIdView,
    }
  },
})
